import React from 'react';
import PersonalError from './PersonalError';

const File = (props) => {
    const {name,  formik , placeholder , icon} = props;
    return (
        <div className="form-group icon-group position-relative">
          <input type="text"  className="form-control" placeholder={placeholder} disabled readOnly dir='ltr'  />
        
          <input type="file" name={name}   id={name} className="file_input" onChange={(e)=> formik.setFieldValue(name, e.target.files[0])} />
        <span className="icon-inside">
          <i className={icon}></i>
        </span>
        <PersonalError
          errors={formik.errors}
          touched={formik.touched}
          name={name}
        
        />
      </div>
    );
}

export default File;
